import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import i18n from "../../../../constants/i18n";

import getUserEventsStore from "../../../../stores/user-store/events-store";
import Et3Table from "../../../../core/et3-table";
import {
  USER_DEACTIVATIONS_HEADERS,
  USER_EVENTS_HEADERS,
  USER_EVENTS_VERIFY_EMAIL_HEADERS
} from "../../../../constants/table-custom-headers/User";
import { isWithinLast24Hours } from "../../../../helpers/et3-date-helper";

const UserEventsData = withLiteObserverAndTheme(() => {
  const userBreachessData = getUserEventsStore().getUserBreachesData();
  const userEventsData = getUserEventsStore().getUserEventsData();
  const emailEventsData =
    getUserEventsStore().userEmailVerifyEventsDataOrdered.get();
  const getUserDeactivationsData =
    getUserEventsStore().userDeactivationsDataOrdered.get();

  return (
    <React.Fragment>
      <Et3Table
        columns={USER_EVENTS_HEADERS}
        title={i18n.get("USER_BREACHES_TABLE")}
        rows={userBreachessData}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const recentBreaches = userBreachessData.filter((breach) =>
            isWithinLast24Hours(breach.date)
          );
          if (recentBreaches.length > 1)
            return isWithinLast24Hours(row.date) && "table-recent-cell-class";
        }}
        titleKey={"USER_BREACHES_TABLE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={USER_EVENTS_HEADERS}
        title={i18n.get("USER_EVENTS_TABLE")}
        rows={userEventsData}
        shouldBeFlagged={false}
        titleKey={"USER_EVENTS_TABLE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={USER_EVENTS_VERIFY_EMAIL_HEADERS}
        title={i18n.get("USER_EMAIL_EVENTS_TABLE")}
        rows={emailEventsData}
        shouldBeFlagged={false}
        titleKey={"USER_EMAIL_EVENTS_TABLE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={USER_DEACTIVATIONS_HEADERS}
        title={i18n.get("USER_DEACTIVATIONS_TABLE")}
        rows={getUserDeactivationsData}
        shouldBeFlagged={false}
        titleKey={"DEACTIVATION_ACTIVITY"}
      />
    </React.Fragment>
  );
});
export default UserEventsData;
